// de marketing copy. Mirrors the EN source 1:1 (see types.ts).
import type { MkPack } from './types'

const pack: MkPack = {
  "features": {
    "custom-domains": {
      "name": "Eigene Domains",
      "title": "Eigene Signatur-Domains für jeden Kunden",
      "desc": "Elektronische Signatur auf Ihrer eigenen Domain, etwa sign.ihrefirma.de. Ein CNAME-Eintrag genügt, DNS-Prüfung und TLS-Zertifikat laufen automatisch.",
      "h1": "Ihre Domain, Ihre Marke, unser Signaturdienst",
      "lead": "Empfänger öffnen Signaturlinks auf sign.ihrefirma.de, nicht auf unserer Adresse. Jede Organisation erhält eine eigene verifizierte Domain mit automatischem TLS-Zertifikat, auf derselben gemeinsamen Plattform.",
      "sections": [
        {
          "h2": "In wenigen Minuten eingerichtet",
          "body": "Fügen Sie die Domain in den Einstellungen Ihrer Organisation hinzu und legen Sie bei Ihrem DNS-Anbieter einen CNAME-Eintrag an. Sobald der Eintrag aufgelöst wird, prüft sign.yt ihn und stellt beim ersten Aufruf ein Let's-Encrypt-Zertifikat aus.\n\nKein separates Deployment, keine Zertifikatsdateien zum Hochladen oder Erneuern."
        },
        {
          "h2": "Jede Anfrage landet in der richtigen Organisation",
          "body": "Die Plattform ermittelt die Organisation anhand des Host-Headers jeder Anfrage. Signaturseiten, E-Mails und die Anmeldeseite auf Ihrer Domain zeigen Ihr Logo und Ihre Farben, und Daten gelangen nie von einem Mandanten zum anderen."
        },
        {
          "h2": "Gemacht für Betreiber mit vielen Marken",
          "body": "Virtuelle Büros, Coworking-Betreiber und Steuerkanzleien führen oft mehrere Marken. Jede Organisation kann eine eigene Domain, ein eigenes Branding und einen eigenen E-Mail-Absender nutzen, während Sie alles über ein Konto verwalten."
        }
      ],
      "faq": [
        {
          "q": "Welche Tarife enthalten eine eigene Domain?",
          "a": "Eigene Domains sind ab dem Tarif Professional verfügbar."
        },
        {
          "q": "Muss ich TLS-Zertifikate selbst verwalten?",
          "a": "Nein. Zertifikate werden automatisch ausgestellt und erneuert, sobald Ihr DNS-Eintrag auf die Plattform zeigt."
        },
        {
          "q": "Kann ich die sign.yt-Adresse weiter nutzen?",
          "a": "Ja. Links auf der Plattform-Domain funktionieren weiterhin; die eigene Domain ist eine Ergänzung, keine Migration."
        },
        {
          "q": "Nutzen auch die Prüflinks meine Domain?",
          "a": "QR-Code und Kurzlink auf jedem signierten Dokument zeigen standardmäßig auf verify.sign.yt. Die Umstellung auf Ihre eigene Domain ist Teil des kostenpflichtigen Add-ons Full customization."
        }
      ]
    },
    "white-label-branding": {
      "name": "White-Label-Branding",
      "title": "White-Label-Branding für die E-Signatur",
      "desc": "Ihr Logo, Ihre Farben und eines von vier Seitenthemen auf jeder Signaturseite, Prüfseite und E-Mail. Teams erhalten ein eigenes Design, oder Sie sperren es.",
      "h1": "Signaturseiten im Erscheinungsbild Ihres Unternehmens",
      "lead": "Empfänger sehen Ihr Logo, Ihre Farben und Ihren Namen, von der ersten E-Mail bis zum signierten PDF. sign.yt bleibt im Hintergrund.",
      "sections": [
        {
          "h2": "Ihre Marke an jedem Berührungspunkt",
          "body": "Laden Sie ein Logo hoch, legen Sie einen Markennamen und eine Primärfarbe fest, und Empfänger sehen beides auf der Signaturseite und auf der öffentlichen Prüfseite jedes signierten Dokuments. Dieselben Einstellungen gelten für Benachrichtigungs-E-Mails, zusammen mit Ihrem Absendernamen und Ihrer E-Mail-Fußzeile. Die Anmeldeseite unterstützt zusätzlich ein Favicon, eine Sekundärfarbe und einen kurzen Begrüßungstext.\n\nWählen Sie eines von vier Seitenthemen: klassisch, minimal, dunkel oder kräftig. Jedes Thema arbeitet mit Ihrer Markenfarbe und passt sie bei Bedarf an, damit Text gut lesbar bleibt.\n\nEmpfänger erkennen, wer sie um eine Unterschrift bittet. Das schafft Vertrauen und verringert die Zahl der \"Ist das Phishing?\"-Rückfragen, die Ihr Team beantworten muss."
        },
        {
          "h2": "Ein eigenes Erscheinungsbild für jedes Team",
          "body": "Sie betreiben mehrere Standorte oder Marken in einer Organisation? Jedes Team kann Logo, Farben, Thema und Absendernamen überschreiben. Ein von einem Team versendetes Dokument zeigt dessen Erscheinungsbild auf der Signaturseite, auf der Prüfseite und in den E-Mails, sodass ein Vertrag aus Ihrem Warschauer Büro anders aussieht als einer aus Krakau.\n\nWenn Sie Einheitlichkeit brauchen, kann ein Organisations-Admin das Team-Branding mit einem Schalter sperren, und alle Teams nutzen überall das Erscheinungsbild der Organisation."
        },
        {
          "h2": "Kein Plattform-Hinweis in bezahlten Tarifen",
          "body": "Im Tarif Starter zeigen Anmelde- und Organisationsseiten einen kleinen Hinweis \"Powered by sign.yt\". Ab dem Tarif Professional entfällt dieser Hinweis, und das Erlebnis gehört ganz Ihnen. In Kombination mit einer eigenen Domain unterschreiben Empfänger unter Ihrer Adresse, während sign.yt im Hintergrund bleibt.\n\nJedes signierte Dokument enthält einen QR-Code und einen Kurzlink wie verify.sign.yt/k3Fq9ZxT2mPa7LwB zu seiner öffentlichen Prüfseite. Mit dem kostenpflichtigen Add-on Full customization nutzen auch diese Links Ihre eigene Domain.\n\nDas Branding wird an einer Stelle aufgelöst, vom Team über die Organisation bis zu den Plattform-Standards. So bleiben E-Mails, Signaturseiten und Prüfseiten einheitlich, ohne dass jemand Einstellungen von Hand kopiert."
        }
      ],
      "faq": [
        {
          "q": "Was kann ich anpassen?",
          "a": "Logo, Markenname, Primärfarbe, Seitenthema, E-Mail-Absendername und E-Mail-Fußzeile. Die Anmeldeseite unterstützt zusätzlich ein Favicon, eine Sekundärfarbe und einen Begrüßungstext."
        },
        {
          "q": "Welche Seitenthemen stehen zur Auswahl?",
          "a": "Vier: klassisch, minimal, dunkel und kräftig. Das Thema gilt für die Signaturseite und die öffentliche Prüfseite."
        },
        {
          "q": "Kann jedes Team ein eigenes Branding haben?",
          "a": "Ja. Ein Team kann Logo, Farben, Thema und Absendernamen überschreiben. Seine Dokumente zeigen dieses Erscheinungsbild auf der Signaturseite, der Prüfseite und in E-Mails, sofern ein Admin das Team-Branding nicht für die gesamte Organisation sperrt."
        },
        {
          "q": "Gilt das Branding auch für E-Mails?",
          "a": "Ja. Benachrichtigungs-E-Mails verwenden das Branding der Organisation oder, falls vorhanden, das des Teams, einschließlich Absendername und Fußzeile."
        },
        {
          "q": "Wo erscheint \"Powered by sign.yt\"?",
          "a": "Nur im Tarif Starter, auf den Anmelde- und Organisationsseiten. Ab Professional entfällt der Hinweis."
        },
        {
          "q": "Wohin führen die Prüflinks?",
          "a": "Standardmäßig zu verify.sign.yt, einer kurzen Adresse, die die Prüfseite des Dokuments in Ihrem Branding öffnet. Prüflinks auf Ihrer eigenen Domain sind Teil des kostenpflichtigen Add-ons Full customization."
        }
      ]
    },
    "pades-electronic-signature": {
      "name": "PAdES-Signaturen",
      "title": "Elektronische PAdES-Signatur für jedes PDF",
      "desc": "Jeder Unterzeichner erhält eine kryptografische PAdES-Signatur im PDF, dazu ein Plattform-Siegel und ein Abschlusszertifikat. Spätere Änderungen fallen auf.",
      "h1": "Ein kryptografisches Siegel, nicht nur das Bild einer Unterschrift",
      "lead": "sign.yt klebt nicht einfach eine gezeichnete Unterschrift auf die Seite. Jede Signatur wird als PAdES-Signatur in das PDF eingebettet, sodass jede spätere Änderung der Datei erkennbar ist.",
      "sections": [
        {
          "h2": "Eine PAdES-Signatur pro Unterzeichner",
          "body": "Sobald ein Empfänger fertig ist, setzt sign.yt eine inkrementelle PAdES-Signatur mit einem Zertifikat, das die Zertifizierungsstelle der Plattform für genau diesen Unterzeichner ausstellt. Signaturen werden nacheinander hinzugefügt, frühere bleiben gültig.\n\nNeue Schlüssel verwenden ECDSA P-384 mit SHA-384. Wenn alle Parteien unterschrieben haben, schließt ein abschließendes Plattform-Siegel das Dokument.\n\nJeder Unterzeichner erscheint mit eigenem Eintrag, Namen und Signaturzeitpunkt im Signaturbereich des PDFs, statt eines anonymen Stempels für das ganze Dokument."
        },
        {
          "h2": "Vertrauenswürdige Zeit und Langzeitvalidierung",
          "body": "sign.yt kann jeder Signatur einen RFC-3161-Zeitstempel eines Zeitstempeldienstes hinzufügen. Ist ein Zeitstempel konfiguriert, wird das abschließende Siegel um Validierungsdaten und einen Dokumentzeitstempel erweitert (PAdES-B-LTA), sodass die Signatur auch in vielen Jahren noch prüfbar ist.\n\nOhne Zeitstempeldienst entstehen die Signaturen auf dem Basisniveau PAdES-B-B. In beiden Fällen deckt die Signatur jedes Byte des Dokuments so ab, wie es in diesem Moment aussah."
        },
        {
          "h2": "Auch außerhalb von sign.yt prüfbar",
          "body": "Die signierte Datei ist ein Standard-PDF. Adobe Acrobat Reader und andere PDF-Reader mit Signaturunterstützung listen die Signaturen auf und markieren jede Änderung nach der Unterzeichnung.\n\nJeder kann das PDF außerdem ohne Konto in den öffentlichen sign.yt-Prüfer ziehen und sehen, wer wann unterschrieben hat und ob die Bytes unverändert sind.\n\nDer Prüfer kontrolliert, ob die Signatur die gesamte Datei abdeckt und ob das Dokument das sign.yt-Plattform-Siegel trägt. Wo der EU-DSS-Validator aktiviert ist, zeigt er zusätzlich ein eIDAS-Ergebnis für jede Signatur.\n\nJedes abgeschlossene Dokument erhält auf seinem Abschlusszertifikat einen QR-Code und eine kurze verify.sign.yt-Adresse. Sie öffnet eine öffentliche Seite mit maskierten Namen der Unterzeichner, Signaturdaten, dem finalen Hash, dem Siegel und dem Status der Bitcoin-Verankerung, und jeder kann prüfen, ob seine Kopie der Datei identisch ist."
        },
        {
          "h2": "Nachweise direkt im Dokument",
          "body": "An das signierte PDF wird ein Abschlusszertifikat angehängt. Für jeden Unterzeichner enthält es die E-Mail-Adresse, die Verifizierungsmethode, die Zeitpunkte von Versand, Ansicht und Unterzeichnung, IP-Adresse und User-Agent sowie die Einwilligungserklärung, die vor der Unterzeichnung bestätigt wurde. Die Nachweise reisen mit der Datei, nicht nur in unserer Datenbank.\n\nDer Hash des finalen PDFs wird zudem über OpenTimestamps in Bitcoin verankert, und das gesamte Paket lässt sich als ein Nachweis-ZIP herunterladen.\n\nWird eine Signatur jemals angezweifelt, haben Sie alles in einer Datei, die Sie einem Anwalt, einem Prüfer oder einem Gericht übergeben können."
        }
      ],
      "faq": [
        {
          "q": "Ist eine Signatur mit sign.yt rechtsverbindlich?",
          "a": "Nach eIDAS darf einer elektronischen Signatur die Rechtswirkung nicht allein deshalb abgesprochen werden, weil sie elektronisch ist. Wo das Gesetz die Schriftform verlangt, verwenden Sie eine qualifizierte elektronische Signatur eines qualifizierten Vertrauensdiensteanbieters. Signaturen mit Profil Zaufany (staatliches polnisches eID-Profil) und e-dowód (polnischer elektronischer Personalausweis) über Węzeł Podpisu (staatlicher polnischer Signaturdienst) sind ebenfalls verfügbar, sofern aktiviert."
        },
        {
          "q": "Zeigt Adobe Reader die Signaturen an?",
          "a": "Ja. Die Signaturen sind Standard-PAdES und erscheinen im Signaturbereich. Ob Adobe die Identität des Unterzeichners als vertrauenswürdig markiert, hängt von der eigenen Vertrauensliste von Adobe ab."
        },
        {
          "q": "Was passiert, wenn jemand das PDF nach der Unterzeichnung ändert?",
          "a": "Die Änderung liegt außerhalb des signierten Bytebereichs, daher melden PDF-Reader und der sign.yt-Prüfer das Dokument als verändert."
        },
        {
          "q": "Brauche ich ein eigenes Zertifikat?",
          "a": "Nein. sign.yt stellt automatisch Zertifikate pro Unterzeichner aus. Qualifizierte Signaturen sind als separate Signaturmethode verfügbar."
        }
      ]
    },
    "trusted-timestamps": {
      "name": "Vertrauenswürdige Zeitstempel (RFC 3161)",
      "title": "RFC-3161-Zeitstempel mit automatischem Fallback",
      "desc": "Jede Signatur erhält einen RFC-3161-Zeitstempel einer unabhängigen Stelle. Zuerst Certum, bei Ausfall DigiCert, Sectigo und FreeTSA als Ersatz.",
      "h1": "Signaturzeit, bestätigt von einer unabhängigen Stelle",
      "lead": "Die Zeit einer sign.yt-Signatur stammt nicht allein von unserer Serveruhr. Ein Zeitstempeldienst signiert sie mit, damit das Datum standhält, wenn jemand nachfragt.",
      "sections": [
        {
          "h2": "Vier Zeitstempeldienste, eine Signatur",
          "body": "sign.yt fragt den Zeitstempel zuerst bei Certum an. Antwortet Certum nicht, übernimmt der nächste Dienst in der Liste: DigiCert, dann Sectigo, dann FreeTSA. Eine Signatur nutzt von Anfang bis Ende immer denselben Dienst, und ein wieder erreichbarer Hauptdienst wird nach wenigen Minuten erneut verwendet.\n\nSind alle Dienste nicht erreichbar, wird das Dokument trotzdem auf dem Niveau PAdES-B-B signiert, statt endlos zu warten."
        },
        {
          "h2": "Langzeitvalidierung integriert",
          "body": "Mit einem Zeitstempel wird das abschließende Siegel um Validierungsdaten und einen Dokumentzeitstempel erweitert (PAdES-B-LTA). Die Stammzertifikate aller vier Dienste sind in der Plattform enthalten, sodass der Validierungspfad ohne zusätzliche Einrichtung aufgebaut werden kann.\n\nDadurch bleibt die Signatur auch in vielen Jahren prüfbar, nachdem die Signaturzertifikate abgelaufen sind."
        },
        {
          "h2": "Qualifikation auf der Prüfseite sichtbar",
          "body": "Wenn Sie ein signiertes PDF in den Prüfer hochladen, wird jeder Zeitstempel gegen die EU-Vertrauenslisten geprüft. Die Seite zeigt, ob es sich um einen Signatur- oder einen Archivzeitstempel handelt und ob er von einem qualifizierten Zeitstempeldienst (QTSA) stammt, dessen Datum rechtlich als korrekt vermutet wird.",
          "requires": "eidas_validation"
        }
      ],
      "faq": [
        {
          "q": "Was ist ein RFC-3161-Zeitstempel?",
          "a": "Ein kleines, von einem Zeitstempeldienst signiertes Token, das belegt, dass ein bestimmter Hash zu einem bestimmten Zeitpunkt existierte. Es wird in die PDF-Signatur eingebettet."
        },
        {
          "q": "Was passiert, wenn ein Zeitstempeldienst ausfällt?",
          "a": "sign.yt wechselt zum nächsten Dienst in der Liste. Nur wenn alle ausfallen, entsteht die Signatur ohne Zeitstempel."
        },
        {
          "q": "Kann ich einen eigenen Zeitstempeldienst nutzen?",
          "a": "Die Liste der Dienste wird pro Plattform festgelegt. Sprechen Sie uns an, wenn Ihre Verträge einen bestimmten qualifizierten Anbieter erfordern."
        }
      ]
    },
    "bitcoin-anchoring": {
      "name": "Bitcoin-Verankerung",
      "title": "Dokument-Hashes in der Bitcoin-Blockchain",
      "desc": "Jedes abgeschlossene Dokument wird per OpenTimestamps in Bitcoin verankert. Den Nachweis prüft jeder mit Open-Source-Tools, ohne sign.yt vertrauen zu müssen.",
      "h1": "Ein Nachweis, der nicht von uns abhängt",
      "lead": "Wenn ein Dokument abgeschlossen ist, gelangt sein Fingerabdruck in einen Bitcoin-Block. Auch Jahre später kann jeder zeigen, dass die Datei zu diesem Zeitpunkt existierte, selbst wenn es sign.yt nicht mehr gibt.",
      "sections": [
        {
          "h2": "Was verankert wird",
          "body": "sign.yt verankert über OpenTimestamps die SHA-256-Hashes des signierten PDFs, des Audit-Trails und des Kopfes der Audit-Kette. Nur Hashes verlassen die Plattform, niemals das Dokument oder personenbezogene Daten.\n\nDer Nachweis wird in der Regel innerhalb weniger Stunden in einem Bitcoin-Block bestätigt."
        },
        {
          "h2": "Prüfen Sie selbst",
          "body": "Das Nachweis-ZIP enthält den .ots-Nachweis und die Liste der verankerten Hashes. Prüfen Sie sie mit dem Open-Source-Client ots gegen einen beliebigen Bitcoin-Knoten oder Block-Explorer, ohne Konto und ohne uns zu kontaktieren.\n\nDie öffentliche Prüfseite zeigt außerdem den Verankerungsstatus und die Blockhöhe, mit einem Link zum Block."
        },
        {
          "h2": "Warum eine Blockchain",
          "body": "Eine Datenbankzeile kann jeder ändern, der die Datenbank betreibt. Einen Bitcoin-Block kann niemand ändern. Damit ist die Verankerung eine starke, unabhängige Antwort auf die Frage: \"Existierte diese Datei an diesem Tag, genau in dieser Form?\"."
        }
      ],
      "faq": [
        {
          "q": "Legt sign.yt mein Dokument auf die Blockchain?",
          "a": "Nein. Verankert werden nur Hashes. Ein Hash verrät nichts über den Inhalt, aber jede Änderung an der Datei ergibt einen anderen Hash."
        },
        {
          "q": "Zahle ich für Bitcoin-Transaktionen?",
          "a": "Nein. Öffentliche OpenTimestamps-Kalender bündeln viele Hashes in einer Transaktion, daher fallen keine Gebühren pro Dokument an."
        },
        {
          "q": "Wie lange dauert es, bis der Nachweis endgültig ist?",
          "a": "Meist einige Stunden. Bis dahin wird die Verankerung als ausstehend angezeigt; der Nachweis wird automatisch aktualisiert."
        }
      ]
    },
    "post-quantum-seal": {
      "name": "Post-Quanten-Siegel",
      "title": "Post-Quanten-Siegel: ML-DSA-65 + Ed25519",
      "desc": "Ein zweites Siegel über jedem abgeschlossenen Dokument, signiert mit ML-DSA-65 und Ed25519. Prüfbar auch dann, wenn Quantencomputer heutige Schlüssel brechen.",
      "h1": "Nachweise, die das Quantenzeitalter überstehen",
      "lead": "Heutige Signaturen beruhen auf Mathematik, die ein großer Quantencomputer brechen könnte. sign.yt fügt ein hybrides Post-Quanten-Siegel hinzu, damit Ihre Nachweise über Jahrzehnte ihren Wert behalten.",
      "sections": [
        {
          "h2": "Zwei Algorithmen, beide müssen halten",
          "body": "Das Siegel signiert ein Manifest, das den Hash des finalen PDFs, den Kopf der Audit-Kette und die Nachweise der Unterzeichner verbindet. Es wird zweimal signiert: mit ML-DSA-65 (FIPS 204, post-quantensicher) und mit Ed25519. Das Siegel ist nur gültig, wenn beide Signaturen verifiziert werden, und hält damit, solange einer der beiden Algorithmen ungebrochen bleibt.\n\nEs ist ein ergänzender Nachweis neben der PAdES-Signatur, kein Ersatz für eine qualifizierte Signatur."
        },
        {
          "h2": "Offline prüfbar",
          "body": "Die Siegeldatei ist Teil des Nachweis-ZIPs. Laden Sie sie zusammen mit dem PDF in den öffentlichen Prüfer hoch oder prüfen Sie sie offline gegen die veröffentlichten öffentlichen Schlüssel.\n\nEin Offline-Stammschlüssel zertifiziert oder widerruft die Arbeitsschlüssel. Sein privater Teil berührt nie einen Server. Ein kompromittierter Arbeitsschlüssel kann widerrufen werden, und Siegel von widerrufenen oder nicht zertifizierten Schlüsseln bestehen die Prüfung nicht."
        },
        {
          "h2": "Schlüssel in AWS KMS",
          "body": "Auf dieser Plattform liegen die Siegelschlüssel im AWS Key Management Service. Die Signatur erfolgt im HSM, die privaten Schlüssel verlassen es nie; jede Signatur wird vor dem Speichern lokal geprüft.",
          "requires": "aws_kms"
        }
      ],
      "faq": [
        {
          "q": "Warum brauche ich das schon heute?",
          "a": "Verträge werden jahrelang aufbewahrt. Ein Angreifer kann signierte Dateien heute speichern und versuchen, sie zu fälschen, sobald Quantencomputer stark genug sind. Das Siegel schließt diese Lücke."
        },
        {
          "q": "Ersetzt es die PAdES-Signatur?",
          "a": "Nein. PAdES bleibt die Standardsignatur, die PDF-Reader verstehen. Das Post-Quanten-Siegel ist eine zusätzliche, unabhängige Nachweisebene."
        },
        {
          "q": "Was ist ML-DSA?",
          "a": "Ein Algorithmus für digitale Signaturen, von NIST in FIPS 204 standardisiert und darauf ausgelegt, Angriffen durch Quantencomputer standzuhalten."
        }
      ]
    },
    "public-verification": {
      "name": "Öffentliche Prüfung",
      "title": "Signierte Dokumente per QR-Code prüfen",
      "desc": "Jedes signierte Dokument trägt einen QR-Code und Kurzlink zu einer öffentlichen Prüfseite: maskierte Namen, Signaturdaten, Siegelstatus und Dateivergleich.",
      "h1": "Jeder kann ein Dokument in Sekunden prüfen",
      "lead": "Ein Vertragspartner, eine Bank oder ein Gericht braucht kein Konto, um Ihrem Dokument zu vertrauen. Es genügt, den QR-Code zu scannen oder das PDF in den Prüfer zu ziehen.",
      "sections": [
        {
          "h2": "Ein QR-Code auf jedem Zertifikat",
          "body": "Das Abschlusszertifikat jedes signierten Dokuments enthält einen QR-Code und einen Kurzlink wie verify.sign.yt/k3Fq9ZxT2mPa7LwB. Er öffnet eine öffentliche Seite mit dem Dokumentstatus, der Anzahl und dem Zeitpunkt der Signaturen, dem Hash des signierten Originals, dem Plattform-Siegel, dem Post-Quanten-Siegel und der Bitcoin-Verankerung.\n\nDie Seite verwendet das Branding der Organisation, die das Dokument versendet hat."
        },
        {
          "h2": "Prüfen, ob Ihre Datei identisch ist",
          "body": "Der QR-Code belegt, dass das Dokument in sign.yt existiert. Um zu belegen, dass Ihre Kopie unverändert ist, laden Sie sie auf derselben Seite hoch: Ihr Hash wird mit dem Hash des signierten Originals verglichen, und daneben erscheint der vollständige Signaturbericht."
        },
        {
          "h2": "Keine personenbezogenen Daten öffentlich",
          "body": "Namen der Unterzeichner werden maskiert, zum Beispiel \"J. K*****\", und es werden keine E-Mail-Adressen, Telefonnummern oder IP-Adressen angezeigt. Der Link ist ein langer Zufallscode, der sich nicht erraten lässt, und Abfragen sind begrenzt.\n\nJedes PDF, ob mit sign.yt signiert oder nicht, kann außerdem in den Prüfer gezogen werden, um zu sehen, ob seine Signaturen intakt sind."
        }
      ],
      "faq": [
        {
          "q": "Braucht die prüfende Person ein Konto?",
          "a": "Nein. Sowohl die QR-Seite als auch der PDF-Prüfer sind öffentlich."
        },
        {
          "q": "Was zeigt die öffentliche Seite?",
          "a": "Status, maskierte Namen der Unterzeichner mit Signaturdaten, den finalen Hash sowie den Status von Siegel und Verankerung. Nicht den Inhalt des Dokuments."
        },
        {
          "q": "Können die Links meine eigene Domain nutzen?",
          "a": "Standardmäßig zeigen sie auf verify.sign.yt. Die Umstellung auf Ihre Domain ist Teil des kostenpflichtigen Add-ons Full customization."
        }
      ]
    },
    "sms-email-verification": {
      "name": "SMS- und E-Mail-Verifizierung",
      "title": "SMS- und E-Mail-Code für Unterzeichner",
      "desc": "Bestätigen Sie, wer unterschreibt, mit einem Einmalcode per E-Mail, SMS oder beidem. Codes laufen nach 10 Minuten ab, jede Prüfung steht im Audit-Trail.",
      "h1": "Wissen, wer unterschrieben hat, nicht nur, welcher Link geklickt wurde",
      "lead": "Fügen Sie vor der Unterzeichnung einen Schritt mit Einmalcode hinzu. Der Empfänger weist den Zugriff auf sein Postfach, sein Telefon oder beides nach, und das Ergebnis wird als Nachweis gespeichert.",
      "sections": [
        {
          "h2": "Die Stufe pro Dokument wählen",
          "body": "Für jedes Dokument legen Sie fest, wie streng die Verifizierung sein soll: keine für eine einfache Kenntnisnahme, ein E-Mail-Code für alltägliche Verträge, ein SMS-Code für Vereinbarungen mit höherem Wert oder beides. Bei beiden Methoden bestätigt der Empfänger den E-Mail-Code beim Öffnen des Dokuments und den SMS-Code unmittelbar vor der Unterzeichnung.\n\nDer Empfänger braucht weder ein Konto noch eine App. Der Code kommt dort an, wo er ohnehin ist, und die Signaturseite führt ihn durch den Schritt."
        },
        {
          "h2": "Sechs Ziffern, kurzlebig, schwer zu erraten",
          "body": "Codes bestehen aus sechs zufälligen Ziffern und gelten 10 Minuten. Nach fünf Fehlversuchen ist ein Code verbraucht, ein neuer kann nach 60 Sekunden angefordert werden, und die Prüfversuche pro Link sind pro Tag begrenzt.\n\nFür SMS gilt zusätzlich ein stündliches Limit pro Nummer, das Ihr Konto vor SMS-Pumping schützt.\n\nDiese Limits gelten automatisch, Sie müssen nichts konfigurieren."
        },
        {
          "h2": "SMS über BulkGate",
          "body": "Textnachrichten werden über BulkGate versendet, ein europäisches SMS-Gateway. Sie können einen eigenen Absendernamen mit bis zu 11 Zeichen festlegen, damit der Code von Ihrer Marke kommt und nicht von einer zufälligen Nummer.\n\nTelefonnummern werden im internationalen Format E.164 gespeichert. Kommt eine Nachricht verspätet an, kann der Empfänger nach einer kurzen Wartezeit auf der Signaturseite einen neuen Code anfordern, ohne Sie zu kontaktieren."
        },
        {
          "h2": "Nachweis im Abschlusszertifikat",
          "body": "Die Verifizierungsmethode und der genaue Zeitpunkt jeder Codebestätigung erscheinen im Abschlusszertifikat des signierten PDFs und im Audit-Log. Wird eine Signatur angefochten, können Sie zeigen, welchen Kanal der Unterzeichner kontrollierte.\n\nUnterzeichner, die einen Code verwendet haben, sind klar von denen unterschieden, die ohne Code unterschrieben haben."
        }
      ],
      "faq": [
        {
          "q": "Wie lange ist ein Code gültig?",
          "a": "10 Minuten. Danach fordert der Empfänger auf der Signaturseite einen neuen an."
        },
        {
          "q": "Braucht der Empfänger ein Konto?",
          "a": "Nein. Empfänger unterschreiben über den Link in ihrer E-Mail; der Code ist der einzige zusätzliche Schritt."
        },
        {
          "q": "Kann ich E-Mail und SMS gleichzeitig verlangen?",
          "a": "Ja. Der E-Mail-Code wird beim Öffnen des Dokuments geprüft, der SMS-Code unmittelbar vor der Unterzeichnung."
        },
        {
          "q": "Gibt es eine stärkere Verifizierung als Codes?",
          "a": "Ja. Identitätsprüfung über login.gov.pl, Profil Zaufany (staatliches polnisches eID-Profil) oder qualifizierte Signaturen ist verfügbar, sofern für Ihre Organisation aktiviert."
        }
      ]
    },
    "mobile-signing": {
      "name": "Mobil unterschreiben",
      "title": "Auf dem Smartphone unterschreiben",
      "desc": "Empfänger unterschreiben auf dem Smartphone in einem Bottom Sheet mit fester Aktionsleiste. Einladungen kommen von einer Person, mit eigenem Betreff und Text.",
      "h1": "Die meisten Unterzeichner öffnen den Link auf dem Smartphone",
      "lead": "Deshalb ist die Signaturseite für die Bedienung mit einem Daumen gebaut. Und die E-Mail, die sie dorthin führt, kommt von einem echten Menschen, nicht von einem No-Reply-Roboter.",
      "sections": [
        {
          "h2": "Ein Signaturablauf für kleine Bildschirme",
          "body": "Auf dem Smartphone fließt das PDF mit der Seite, scharf für den Bildschirm gerendert und beim Drehen neu eingepasst. Tippen Sie auf ein Feld oder auf die fixierte Leiste am unteren Rand, und die Signatursteuerung öffnet sich als Bottom Sheet: Unterschrift zeichnen oder tippen, Feld ausfüllen, weiter.\n\nDie Leiste zeigt immer, was noch zu tun ist, und verschwindet, wenn ein Dokument abgelaufen oder storniert ist."
        },
        {
          "h2": "Eine Einladung von einer Person",
          "body": "Die Einladung zeigt den Absender mit Namen, zum Beispiel \"Anna Nowak via sign.yt\" oder mit Ihrem eigenen Markennamen, und Antworten gehen direkt an Anna statt an ein No-Reply-Postfach. Der Standardbetreff nennt, wer um eine Unterschrift bittet und für welches Dokument.\n\nVor dem Versand können Sie den Betreff ändern und eine persönliche Nachricht hinzufügen. Das funktioniert mit dem verwalteten Versand und mit jedem E-Mail-Anbieter, den Sie verbinden."
        },
        {
          "h2": "Weniger \"Ist das Phishing?\"-Rückfragen",
          "body": "Ein bekannter Name, Ihre Marke und eine Nachricht für genau diesen Empfänger machen die E-Mail vertrauenswürdig. Empfänger mit Fragen klicken einfach auf Antworten."
        }
      ],
      "faq": [
        {
          "q": "Braucht der Unterzeichner eine App?",
          "a": "Nein. Die Unterzeichnung funktioniert im Browser des Smartphones über den Link in der E-Mail."
        },
        {
          "q": "Wohin gehen Antworten auf die Einladung?",
          "a": "An die Person, die das Dokument versendet hat. Der Reply-To-Header wird auf den Absender gesetzt."
        },
        {
          "q": "Kann ich den E-Mail-Text selbst schreiben?",
          "a": "Ja. Ändern Sie den Betreff und fügen Sie im Versanddialog eine persönliche Nachricht hinzu."
        }
      ]
    },
    "profil-zaufany-wezel-podpisu": {
      "name": "Profil Zaufany und qualifizierte Signaturen",
      "title": "Profil Zaufany, e-ID und qualifizierte Signatur",
      "desc": "Polnische Unterzeichner nutzen Profil Zaufany, e-dowód oder mObywatel über Węzeł Podpisu, oder eine qualifizierte Signatur eines Vertrauensdiensteanbieters.",
      "h1": "Staatliche Identität für die Dokumente, die sie brauchen",
      "lead": "Manche Verträge brauchen mehr als einen Code. sign.yt ist an Węzeł Podpisu (staatlicher polnischer Signaturdienst) und an qualifizierte Vertrauensdiensteanbieter angebunden, damit Unterzeichner die Identitätswerkzeuge nutzen können, die sie bereits haben.",
      "sections": [
        {
          "h2": "Węzeł Podpisu im Signaturablauf",
          "body": "Für jeden Empfänger können Sie eine Methode von Węzeł Podpisu wählen: Profil Zaufany (staatliches polnisches eID-Profil), e-dowód (polnischer elektronischer Personalausweis), persönliche Signatur (podpis osobisty), mObywatel (staatliche polnische ID-App) oder eine qualifizierte Signatur. Der Empfänger wird zum staatlichen Ablauf weitergeleitet und unterschreibt dort, sign.yt speichert das signierte PDF und gibt das Dokument an den nächsten Unterzeichner weiter.\n\nParallele und sequenzielle Reihenfolgen funktionieren genauso wie bei regulären Signaturen."
        },
        {
          "h2": "Qualifizierte elektronische Signaturen",
          "body": "Eine qualifizierte Signatur (QES) ist die eIDAS-Stufe, die einer handschriftlichen Unterschrift gleichgestellt ist. sign.yt unterstützt zwei Wege: Fernsignatur bei einem qualifizierten Anbieter über die API des Cloud Signature Consortium oder Upload, bei dem der Unterzeichner das PDF mit einem beliebigen QES-Werkzeug signiert und wieder hochlädt.\n\nDie Fernsignatur funktioniert mit Anbietern, die einen CSC-v2-Endpunkt bereitstellen. Der Upload-Weg funktioniert mit Signaturkarten, Cloud-Zertifikaten und anderen qualifizierten Werkzeugen, sodass der Unterzeichner nicht an einen Anbieter gebunden ist."
        },
        {
          "h2": "Frühere Signaturen bleiben intakt",
          "body": "Qualifizierte Signaturen werden inkrementell zur neuesten Revision des Dokuments hinzugefügt. Hochgeladene Dateien werden nur akzeptiert, wenn sie exakt die Bytes erweitern, die sign.yt gesendet hat, und das Signaturzertifikat muss in der EU-Vertrauensliste als qualifiziert geführt sein.\n\nSo können Sie Methoden in einem Dokument kombinieren: Eine Partei unterschreibt mit Profil Zaufany, eine andere mit einem qualifizierten Zertifikat und eine dritte mit einer regulären sign.yt-Signatur, während der Audit-Trail jeden Schritt festhält."
        }
      ],
      "faq": [
        {
          "q": "Brauche ich eine qualifizierte Signatur?",
          "a": "Nur wenn das Gesetz die Schriftform verlangt oder Ihr Vertragspartner es wünscht. Für die meisten Geschäftsverträge genügt eine reguläre elektronische Signatur mit Verifizierung. Klären Sie Einzelfälle mit Ihrem Anwalt."
        },
        {
          "q": "Zahlt der Unterzeichner etwas?",
          "a": "Profil Zaufany, e-dowód und mObywatel sind die eigenen staatlichen Werkzeuge des Unterzeichners. Qualifizierte Zertifikate werden von Vertrauensdiensteanbietern zu deren eigenen Bedingungen ausgestellt."
        },
        {
          "q": "Ist das in jedem Konto verfügbar?",
          "a": "Węzeł Podpisu und Anbindungen an qualifizierte Anbieter werden pro Organisation aktiviert. Schreiben Sie an sales@sign.yt, um sie einzurichten."
        },
        {
          "q": "Welche qualifizierten Werkzeuge funktionieren mit dem Upload-Weg?",
          "a": "Jedes Werkzeug, das eine qualifizierte PAdES-Signatur erzeugt, die in der EU-Vertrauensliste anerkannt ist, zum Beispiel eine Signaturkarte oder ein Cloud-Zertifikat."
        }
      ]
    },
    "email-delivery-providers": {
      "name": "E-Mail-Versand",
      "title": "Signatur-E-Mails von Ihrer eigenen Domain",
      "desc": "Versenden Sie Signatureinladungen über Ihr SMTP, Microsoft 365 (Graph API), Resend, Amazon SES oder Mailgun, mit Prüfung von SPF, DKIM und DMARC.",
      "h1": "Signatur-E-Mails von Ihrer Adresse, über Ihren Anbieter",
      "lead": "Einladungen von Ihrer eigenen Domain werden geöffnet. Verbinden Sie den E-Mail-Dienst, den Sie bereits nutzen, und sign.yt versendet jede Benachrichtigung darüber.",
      "sections": [
        {
          "h2": "Wählen Sie den Anbieter, dem Sie vertrauen",
          "body": "Starten Sie mit dem verwalteten Versand, ganz ohne Konfiguration. Wenn Sie bereit sind, stellen Sie Ihre Organisation auf Ihren eigenen SMTP-Server, Microsoft 365 über die Graph API, Ihr eigenes Resend-Konto, Amazon SES oder Mailgun um.\n\nZugangsdaten der Anbieter werden verschlüsselt gespeichert, nie im Klartext.\n\nJede Organisation wählt einen Anbieter, sodass jede Einladung, Erinnerung und Abschluss-E-Mail auf demselben Weg versendet wird."
        },
        {
          "h2": "Microsoft 365 ohne SMTP-Passwörter",
          "body": "Mit der Graph API versendet sign.yt als Postfach in Ihrem Microsoft-365-Tenant, über eine Azure-App-Registrierung mit der Berechtigung Mail.Send. Kein SMTP-Passwort zum Speichern und keine Basic Authentication, die in Ihrem Tenant aktiviert bleiben muss.\n\nSie wählen die Absenderadresse, zum Beispiel vertraege@ihrefirma.de, sodass Antworten von Empfängern in einem echten Postfach landen, das Ihr Team bereits betreut."
        },
        {
          "h2": "DNS-Einträge für Sie geprüft",
          "body": "Die Einstellungsseite listet die SPF-, DKIM- und DMARC-Einträge auf, die Ihre Absenderdomain für den gewählten Anbieter braucht, fragt sie live ab und zeigt, welche vorhanden sind. So landen weniger Einladungen im Spam.\n\nDKIM-Einträge für Amazon SES werden für Ihre Domain automatisch abgerufen, bei anderen Anbietern zeigt die Seite genau, welche Werte Sie in Ihre DNS-Verwaltung kopieren müssen."
        },
        {
          "h2": "Bounces bleiben nicht unbemerkt",
          "body": "Beim verwalteten Versand markieren unzustellbare und als Spam gemeldete E-Mails den Empfänger als unzustellbar, werden im Audit-Log erfasst und lösen einen recipient.bounced-Webhook aus. So korrigieren Sie die Adresse, statt auf eine Unterschrift zu warten, die nie kommt.\n\nDieselbe Information ist im Dokument neben dem Empfänger sichtbar. Sie erfahren davon, sobald der Anbieter es meldet, nicht erst nach Ablauf der Signaturfrist."
        }
      ],
      "faq": [
        {
          "q": "Welche E-Mail-Anbieter werden unterstützt?",
          "a": "Verwalteter Versand, SMTP, Microsoft 365 über die Graph API, Resend mit eigenem Konto, Amazon SES und Mailgun."
        },
        {
          "q": "Welche SMTP-Ports kann ich nutzen?",
          "a": "Die Ports 25, 465, 587 und 2525, mit TLS."
        },
        {
          "q": "Können Teams unterschiedliche Absendernamen nutzen?",
          "a": "Ja. Der Absendername lässt sich pro Team über das Team-Branding festlegen."
        },
        {
          "q": "Muss ich zum Start etwas konfigurieren?",
          "a": "Nein. Der verwaltete Versand funktioniert sofort; ein eigener Anbieter ist optional."
        }
      ]
    },
    "document-templates": {
      "name": "Dokumentvorlagen",
      "title": "Vorlagen für die E-Signatur und öffentliche Links",
      "desc": "Speichern Sie Verträge als Vorlagen mit Unterzeichnern und Feldern. Wiederverwenden in Sekunden, PDF bei neuem Wortlaut tauschen oder öffentlich teilen.",
      "h1": "Einen Vertrag einmal einrichten, hundertmal versenden",
      "lead": "Vorlagen halten PDF, Rollen der Unterzeichner und Feldpositionen zusammen. Dieselbe Vereinbarung erneut zu versenden dauert ein paar Klicks statt einer neuen Einrichtung.",
      "sections": [
        {
          "h2": "Aus jedem Dokument eine Vorlage",
          "body": "Laden Sie ein PDF hoch und platzieren Sie Signatur-, Datums-, Text- und Kontrollkästchenfelder, oder machen Sie aus einem bereits versendeten Dokument eine Vorlage. Rollen der Unterzeichner und Feldpositionen werden mitgespeichert.\n\nÄndert sich der Wortlaut des Vertrags, aber nicht das Layout, ersetzen Sie das PDF und behalten jedes Feld an seiner Stelle.\n\nVorlagen sind nach Kategorien geordnet, damit Ihr Team schnell die richtige Vereinbarung findet."
        },
        {
          "h2": "Öffentliche Links und QR-Codes",
          "body": "Aktivieren Sie einen öffentlichen Link für eine Vorlage, und jeder mit dem Link kann sie ausfüllen und unterschreiben, zum Beispiel ein Onboarding-Formular oder eine Marketing-Einwilligung. sign.yt erzeugt dazu einen QR-Code für den Link, bereit für einen Flyer oder den Empfangstresen.\n\nEin öffentlicher Link lässt sich jederzeit abschalten und nach Ablaufdatum oder Anzahl der Nutzungen begrenzen. Jede signierte Kopie ist ein eigenes Dokument mit eigenem Audit-Trail."
        },
        {
          "h2": "Ein schneller Start für polnische KMU",
          "body": "Ein Startkatalog schlägt Rollen, Signaturreihenfolge, Verifizierungsstufe und Feldlayout für gängige Dokumente aus virtuellen Büros, Kanzleien, Buchhaltung, Personalwesen und DSGVO vor. Sie laden Ihr eigenes PDF hoch, die Vorlage erledigt den Rest.\n\nDas ist schneller als ein leerer Editor, besonders für Teams, die ihre ersten Vorlagen erstellen. Die Kategorien spiegeln die Branchen wider, mit denen wir am häufigsten arbeiten."
        },
        {
          "h2": "Felder für Sie platziert",
          "body": "Auf Wunsch analysiert sign.yt eine Seite Ihres PDFs und schlägt vor, wo Signatur-, Datums- und Textfelder hingehören. Sie prüfen den Vorschlag, passen ihn an und speichern.\n\nDie Erkennung ist optional und läuft nur, wenn Sie sie anstoßen. Das endgültige Layout entscheiden immer Sie, und Sie können jedes vorgeschlagene Feld verschieben, in der Größe ändern oder löschen, bevor das Dokument an die Empfänger geht."
        }
      ],
      "faq": [
        {
          "q": "Kann ich eine Vorlage aktualisieren, ohne die Felder neu zu setzen?",
          "a": "Ja. Ersetzen Sie das PDF, und die vorhandenen Feldpositionen bleiben erhalten."
        },
        {
          "q": "Wer kann über einen öffentlichen Link unterschreiben?",
          "a": "Jeder, der den Link hat, solange er aktiviert ist. Sie können ihn jederzeit abschalten."
        },
        {
          "q": "Ist die automatische Felderkennung immer aktiv?",
          "a": "Nein. Sie läuft nur, wenn Sie im Feldeditor auf die Schaltfläche klicken."
        }
      ]
    },
    "bulk-send-campaigns": {
      "name": "Massenversand und Kampagnen",
      "title": "Massenversand zur E-Signatur per CSV",
      "desc": "Senden Sie ein Dokument per CSV-Datei an Hunderte Personen. Gedrosselter Versand, Pause und Fortsetzung, Erinnerungen, CSV-Export und öffentliche QR-Kampagnen.",
      "h1": "Ein Dokument, Hunderte Unterzeichner, kein Kopieren und Einfügen",
      "lead": "Jährliche Richtlinien-Updates, neue AGB, erneuerte Einwilligungen. Kampagnen schicken jeder Person ihr eigenes Dokument und verfolgen jede Unterschrift an einem Ort.",
      "sections": [
        {
          "h2": "CSV hochladen, prüfen, senden",
          "body": "Bereiten Sie eine CSV-Datei mit E-Mail, Name und Telefon vor, und sign.yt zeigt eine Vorschau, bevor etwas versendet wird. Jeder Empfänger erhält ein eigenes Dokument, sodass die Unterschrift oder Ablehnung einer Person nie die anderen blockiert.\n\nTypische Anwendungen sind die jährliche Erneuerung von NDAs, aktualisierte Bedingungen für alle Kunden oder eine neue Einwilligung für jeden Mieter. Die Vorschau zeigt Probleme in der Datei, etwa eine fehlende E-Mail-Spalte, bevor etwas versendet wird."
        },
        {
          "h2": "Versand in sicherem Tempo",
          "body": "Kampagnen werden im Hintergrund mit einer Rate pro Organisation versendet, die mit den Erinnerungen geteilt wird. So überflutet eine große Liste weder Ihr Postfach noch überschreitet sie die Limits Ihres Anbieters. Sie können eine laufende Kampagne jederzeit pausieren, fortsetzen oder abbrechen.\n\nDer Versand erfolgt Zeile für Zeile, sodass auch bei mehreren parallelen Workern niemand dasselbe Dokument zweimal erhält."
        },
        {
          "h2": "Nachfassen ohne Tabellenkalkulation",
          "body": "Die Kampagnenansicht zeigt, wer unterschrieben hat und wer nicht. Senden Sie allen Ausstehenden eine Erinnerung, wiederholen Sie fehlgeschlagene Sendungen und exportieren Sie die Ergebnisse als CSV oder die Nachweise als JSON für Ihre Unterlagen.\n\nBei öffentlichen Kampagnen können Sie zusätzlich eine Liste der erwarteten Unterzeichner hinterlegen und auf einen Blick sehen, wer noch fehlt."
        },
        {
          "h2": "Öffentliche Kampagnen mit QR-Code",
          "body": "Sie brauchen Unterschriften von Personen, die noch nicht auf einer Liste stehen, etwa Veranstaltungsteilnehmer oder neue Mieter? Eine öffentliche Kampagne liefert Ihnen einen Link und einen QR-Code, und jeder Besucher unterschreibt seine eigene Kopie.\n\nJede Kopie hat eigene Signaturen, eine eigene Verifizierung und einen eigenen Audit-Trail, genau wie ein aus einer Liste versendetes Dokument."
        }
      ],
      "faq": [
        {
          "q": "Welche Spalten braucht die CSV-Datei?",
          "a": "E-Mail, Name und optional Telefon, das für die SMS-Verifizierung verwendet wird."
        },
        {
          "q": "Kann ich eine Kampagne mittendrin stoppen?",
          "a": "Ja. Pausieren und fortsetzen oder die verbleibenden Sendungen abbrechen."
        },
        {
          "q": "Zählen Erinnerungen zur Versandrate?",
          "a": "Ja. Kampagnen und Erinnerungen teilen sich eine Rate pro Organisation, was den Versand gleichmäßig hält."
        }
      ]
    },
    "smart-documents-gus-vies": {
      "name": "Smarte Dokumente",
      "title": "Vertragsgenerator mit NIP-, GUS- und VIES-Daten",
      "desc": "Verträge aus Vorlagen mit Variablen erzeugen. NIP eingeben, Firmendaten kommen aus GUS, der VAT-Whitelist des MF und VIES, danach zur Unterschrift senden.",
      "h1": "Verträge, die sich anhand einer Steuernummer selbst ausfüllen",
      "lead": "Smarte Dokumente machen aus Ihrem Vertragstext ein Formular. Geben Sie eine NIP ein, übernehmen Sie die Firmendaten aus öffentlichen Registern und erzeugen Sie unterschriftsreife PDFs.",
      "sections": [
        {
          "h2": "Firmendaten aus öffentlichen Registern",
          "body": "Geben Sie eine polnische NIP ein, und sign.yt kombiniert Daten aus GUS (REGON, KRS, Rechtsform, Adresse) mit der VAT-Whitelist des polnischen Finanzministeriums (USt-Status und Bankkonten). Für andere EU-Länder nutzt es VIES.\n\nIst eine Quelle nicht erreichbar, füllen die anderen aus, was sie können, und Sie sehen eine Warnung statt eines Fehlers."
        },
        {
          "h2": "Vorlagen mit echter Logik",
          "body": "Schreiben Sie den Vertrag im integrierten Editor oder importieren Sie eine .docx-Datei, in der Platzhalter in eckigen Klammern oder doppelten geschweiften Klammern zu Variablen werden. Variablen haben Typen wie Betrag, Datum, NIP, IBAN oder Liste, und Sie können bedingte Abschnitte, wiederholte Zeilen und berechnete Werte hinzufügen.\n\nBerechnete Werte nutzen eine sichere Ausdruckssprache, sodass Summen, Netto- und Bruttobeträge oder Fälligkeitsdaten für Sie ermittelt werden. Das fertige Dokument wird als PDF gerendert und durchläuft den regulären Signaturablauf."
        },
        {
          "h2": "Polnische Formatierung integriert",
          "body": "Beträge werden nach polnischer Konvention formatiert und können in Worten ausgeschrieben werden, Datumsangaben folgen polnischen Gepflogenheiten, und Zahlungen lassen sich automatisch in Raten aufteilen. Keine manuellen \"słownie\"-Felder mehr.\n\nWerte werden vor der Erzeugung anhand ihres Typs geprüft, sodass eine ungültige NIP oder IBAN im Formular auffällt und nicht erst im unterschriebenen Vertrag. Jedes erzeugte PDF sieht aus wie ein von Ihrem Büro von Hand vorbereitetes Dokument."
        },
        {
          "h2": "Ein Formular, ein ganzes Paket",
          "body": "Fassen Sie mehrere Dokumente zu einem Paket zusammen, etwa einen Vertrag, einen Anhang und eine DSGVO-Klausel. Gemeinsame Variablen werden einmal ausgefüllt, und sign.yt erzeugt und versendet alle Dokumente zusammen.\n\nDas Paketformular zeigt jede Variable nur einmal, auch wenn sie in mehreren Dokumenten vorkommt. Das verhindert Übertragungsfehler zwischen Hauptvertrag und Anlagen, und der Empfänger unterschreibt das gesamte Paket in einem Ablauf."
        }
      ],
      "faq": [
        {
          "q": "Welche Register werden genutzt?",
          "a": "GUS BIR (REGON-Datenbank), die VAT-Whitelist des polnischen Finanzministeriums und das EU-System VIES."
        },
        {
          "q": "Können Unterzeichner ihre eigenen Firmendaten eintragen?",
          "a": "Ja. Auf der Signaturseite kann ein Empfänger seine NIP eingeben und seine Firmendaten aus den Registern abrufen."
        },
        {
          "q": "Kann ich meine bestehenden Word-Verträge importieren?",
          "a": "Ja. Laden Sie eine .docx-Datei hoch, und Platzhalter wie [NAME KUNDE] oder {{client.name}} werden zu Variablen."
        }
      ]
    },
    "api-webhooks": {
      "name": "API und Webhooks",
      "title": "E-Signatur-REST-API mit signierten Webhooks",
      "desc": "Dokumente aus Ihrer Software erstellen, senden und verfolgen. API-Schlüssel mit Scopes, HMAC-signierte Webhooks mit Wiederholungen und versionierte REST API.",
      "h1": "E-Signaturen direkt in der Software, die Sie bereits nutzen",
      "lead": "Ihr CRM, ERP oder Kundenportal kann Dokumente erstellen, zur Unterschrift senden und sofort reagieren, wenn sie unterschrieben sind, ohne dass jemand sign.yt öffnet.",
      "sections": [
        {
          "h2": "Eine versionierte REST API",
          "body": "Alles liegt unter api.sign.yt/v1 und spricht JSON: Dokumente, Empfänger, Felder, Vorlagen und Webhooks. Erstellen Sie ein Dokument aus einer Vorlage, versenden Sie es und laden Sie das signierte PDF mit wenigen Aufrufen herunter.\n\nJede Anfrage ist auf die Organisation beschränkt, der der API-Schlüssel gehört, sodass eine Integration nie die Dokumente eines anderen Mandanten sieht. Fehler kommen als strukturiertes JSON mit klaren Statuscodes zurück, was den Client-Code einfach hält."
        },
        {
          "h2": "API-Schlüssel mit Scopes",
          "body": "Jede Organisation erstellt eigene API-Schlüssel und gewährt jedem Schlüssel nur die Scopes, die er braucht, Lesen oder Schreiben pro Bereich. Schlüssel werden gehasht gespeichert, nach der Erstellung wird nur das Präfix angezeigt, und jeder Schlüssel ist auf 100 Anfragen pro Sekunde begrenzt.\n\nWiderrufen Sie einen Schlüssel jederzeit, und Integrationen, die ihn nutzen, stoppen sofort. Der Zeitpunkt der letzten Nutzung hilft, Schlüssel zu finden, die niemand mehr braucht."
        },
        {
          "h2": "Webhooks, denen Sie vertrauen können",
          "body": "Abonnieren Sie Ereignisse wie document.sent, document.viewed, document.signed, document.completed, document.rejected, document.expired und recipient.bounced. Jede Zustellung ist mit HMAC-SHA256 über einen Zeitstempel und den unveränderten Body signiert, sodass Sie prüfen können, dass sie von sign.yt stammt, und Replays abweisen können.\n\nEndpunkte werden vor jeder Zustellung erneut geprüft, um Anfragen an interne Adressen zu blockieren. Jede Anfrage enthält außerdem den Ereignisnamen und eine Zustell-ID in den Headern, sodass Sie Ereignisse leicht routen und deduplizieren können."
        },
        {
          "h2": "Wiederholungen integriert",
          "body": "Ist Ihr Endpunkt nicht erreichbar, versucht sign.yt es erneut nach 1 Minute, 5 Minuten, 30 Minuten, 2 Stunden und 12 Stunden. Jede Zustellung hat eine stabile ID zur Deduplizierung, und fehlgeschlagene Zustellungen werden aufbewahrt, damit nichts unbemerkt verloren geht.\n\nJeder Versuch wird mit einem frischen Zeitstempel neu signiert, sodass auch eine Wiederholung Stunden später die Prüfung des Replay-Fensters auf Ihrer Seite besteht."
        }
      ],
      "faq": [
        {
          "q": "Wie authentifiziere ich mich?",
          "a": "Senden Sie Ihren API-Schlüssel als Bearer-Token im Authorization-Header."
        },
        {
          "q": "Wie prüfe ich einen Webhook?",
          "a": "Berechnen Sie mit Ihrem Webhook-Secret HMAC-SHA256 über den Zeitstempel-Header, einen Punkt und den unveränderten Body, und vergleichen Sie das Ergebnis mit dem Header X-Signyt-Signature."
        },
        {
          "q": "Was passiert, wenn mein Endpunkt ausfällt?",
          "a": "sign.yt versucht es fünfmal über etwa 15 Stunden erneut und markiert die Zustellung dann als fehlgeschlagen."
        },
        {
          "q": "Welche Tarife enthalten API-Zugang?",
          "a": "API-Schlüssel und Webhooks sind ab dem Tarif Business enthalten."
        }
      ]
    },
    "audit-trail": {
      "name": "Audit-Trail",
      "title": "Manipulationssicherer Audit-Trail für E-Signaturen",
      "desc": "Jede Aktion steht in einem unveränderlichen, per Hash verketteten Audit-Log. Signaturen sind pro Dokument verkettet, jedes PDF erhält ein Abschlusszertifikat.",
      "h1": "Ein Audit-Trail, der zeigt, ob jemand die Geschichte umschreiben wollte",
      "lead": "Wer gesendet, wer geöffnet, wer verifiziert und wer unterschrieben hat, mit IP-Adressen und Zeitstempeln. Einträge sind mit SHA-256 verkettet, sodass ein entfernter oder veränderter Eintrag die Kette bricht.",
      "sections": [
        {
          "h2": "Nur anfügbares, per Hash verkettetes Log",
          "body": "Jeder Audit-Eintrag speichert den Hash des vorherigen Eintrags in der Kette Ihrer Organisation. Einträge werden ausschließlich hinzugefügt, nie geändert oder gelöscht, was die Datenbank selbst erzwingt, und jeder Mandant hat seine eigene unabhängige Kette.\n\nWürde jemand einen Datensatz direkt in der Datenbank entfernen oder bearbeiten, ließe sich die Kette nicht mehr verifizieren. Die Ereignisse decken den gesamten Lebenszyklus ab, von Anmeldung und Einstellungsänderungen bis zu Versand, Ansicht und Unterzeichnung."
        },
        {
          "h2": "Miteinander verknüpfte Signaturen",
          "body": "Jede Signatur auf einem Dokument verweist auf den Hash der vorherigen. Bevor ein Dokument als abgeschlossen markiert wird, durchläuft sign.yt die gesamte Kette und verweigert den Abschluss, wenn etwas nicht übereinstimmt.\n\nEine gebrochene Kette wird im Audit-Log festgehalten, sodass ein Problem sichtbar wird, statt stillschweigend in ein fertiges PDF versiegelt zu werden. Zusammen mit den PAdES-Signaturen ergibt das zwei unabhängige Wege, die Reihenfolge der Ereignisse zu belegen."
        },
        {
          "h2": "Ausdrückliche Einwilligung und Bitcoin-Verankerung",
          "body": "Vor der Unterzeichnung bestätigt jeder Unterzeichner eine Einwilligungserklärung. Deren Text, Sprache und Hash werden mit der Signatur und im Audit-Log gespeichert, sodass Sie genau zeigen können, wozu die Person zugestimmt hat.\n\nWenn ein Dokument abgeschlossen ist, verankert sign.yt die Hashes des signierten PDFs, des Audit-Trails und des Kopfes der Audit-Kette über OpenTimestamps in Bitcoin. Der Nachweis zeigt, dass die Dateien zum Zeitpunkt dieses Blocks existierten, und lässt sich mit dem Open-Source-Werkzeug ots prüfen, ohne sich auf sign.yt zu verlassen."
        },
        {
          "h2": "Abschlusszertifikat im PDF",
          "body": "Das signierte PDF endet mit einem Abschlusszertifikat: Name, E-Mail, Rolle und Verifizierungsmethode jedes Unterzeichners, die Zeitpunkte von Versand, Ansicht und Unterzeichnung, IP-Adresse und Browser. Ihre Nachweise reisen mit der Datei.\n\nDa das Zertifikat Teil des PDFs ist, bleibt es bei jeder Kopie des Dokuments erhalten, wo auch immer sie gespeichert oder weitergeleitet wird. Sein QR-Code und Kurzlink öffnen eine öffentliche Prüfseite für das Dokument."
        },
        {
          "h2": "Finden und exportieren, was Sie brauchen",
          "body": "Filtern Sie das Audit-Log der Organisation nach Ereignistyp oder laden Sie die vollständige Historie eines einzelnen Dokuments als CSV für Ihren Anwalt oder Prüfer herunter.\n\nDas Nachweis-ZIP bündelt alles in einem Download: das signierte PDF, einen eigenständigen Audit-Trail, den OpenTimestamps-Nachweis, das Zertifikat des Plattform-Siegels, ein Manifest der SHA-256-Hashes und eine README, die erklärt, wie jeder Teil zu prüfen ist. Auch Unterzeichner können es herunterladen.\n\nEinträge erfassen den Akteur, E-Mail und IP-Adresse, das Ziel und die Details des Ereignisses. Organisations-Admins sehen nur ihre eigene Organisation, und das Log ist paginiert, sodass auch lange Historien schnell durchsucht werden können."
        }
      ],
      "faq": [
        {
          "q": "Kann ein Audit-Eintrag bearbeitet oder gelöscht werden?",
          "a": "Nein. Das Log ist nur anfügbar, und jede Änderung außerhalb der Anwendung bricht die Hash-Kette."
        },
        {
          "q": "Was enthält das Abschlusszertifikat?",
          "a": "Identität des Unterzeichners, Verifizierungsmethode, Zeitpunkte von Versand, Ansicht und Unterzeichnung, IP-Adresse und User-Agent."
        },
        {
          "q": "Kann ich den Audit-Trail exportieren?",
          "a": "Ja. Die Historie jedes Dokuments lässt sich als CSV herunterladen, das vollständige Nachweispaket als ZIP."
        },
        {
          "q": "Was ist die Bitcoin-Verankerung?",
          "a": "Ein OpenTimestamps-Nachweis, dass die Dokument-Hashes existierten, als ein bestimmter Bitcoin-Block erzeugt wurde. Er wird innerhalb von Stunden bestätigt und lässt sich unabhängig von sign.yt prüfen."
        }
      ]
    },
    "gdpr-rodo-compliance": {
      "name": "DSGVO-Konformität",
      "title": "DSGVO-konforme E-Signatur mit Verschlüsselung",
      "desc": "Datenexport und Löschanfragen direkt im Produkt, PDFs im Ruhezustand verschlüsselt mit eigenem Schlüssel pro Organisation und strikte Mandantentrennung.",
      "h1": "Datenschutz im Produkt, nicht in einer Tabelle",
      "lead": "Betroffenenanfragen, Verschlüsselung und Mandantentrennung sind Teil von sign.yt. Sie verbringen weniger Zeit mit DSGVO-Papierkram und behalten die signierten Dokumente, die Sie gesetzlich aufbewahren müssen.",
      "sections": [
        {
          "h2": "Export auf Anfrage",
          "body": "Nutzer können alle ihre Daten als ZIP-Datei herunterladen: Profil, Organisationen, Metadaten zu Dokumenten und Signaturen, Kontakte und die Audit-Einträge, die sich auf sie beziehen. Personen ohne Konto, etwa Empfänger, können ihre Daten per E-Mail anfordern und erhalten einen einmaligen Download-Link.\n\nÖffentliche Anfragen sind pro E-Mail-Adresse und pro IP-Adresse begrenzt, sodass niemand das System überfluten kann."
        },
        {
          "h2": "Löschung, die die Nachweise erhält",
          "body": "Wenn ein Nutzer das Recht auf Vergessenwerden ausübt, anonymisiert sign.yt ihn: Namen und E-Mail-Adressen werden durch neutrale Kennungen ersetzt, Sitzungen widerrufen und Anmeldemethoden entfernt. Signierte Dokumente bleiben erhalten, denn ihre Löschung würde den Audit-Trail und die Rechte der anderen Parteien beeinträchtigen.\n\nSuper-Admin-Konten erfordern eine zusätzliche Bestätigung, die vor versehentlichem Löschen schützt."
        },
        {
          "h2": "Im Ruhezustand verschlüsselt, pro Organisation",
          "body": "Hochgeladene und signierte PDFs werden mit AES-256-GCM verschlüsselt, mit einem Schlüssel, der für jede Organisation separat abgeleitet wird. Zugangsdaten für E-Mail- und SMS-Anbieter werden mit Verschlüsselung auf Feldebene gespeichert, nie im Klartext.\n\nJede Datei ist an ihre Organisation und ihr Dokument gebunden, sodass ein an die falsche Stelle kopiertes Objekt dort nicht entschlüsselt werden kann. Schlüssel liegen nie in der Datenbank neben den Daten, die sie schützen."
        },
        {
          "h2": "Mandanten vermischen sich nie",
          "body": "Jede Abfrage ist auf die Organisation beschränkt, zu der sie gehört. Anfragen auf einer eigenen Domain werden genau einer Organisation zugeordnet, und Audit-Ketten werden pro Mandant geführt.\n\nDiese Trennung ermöglicht es vielen Unternehmen und vielen Marken, eine Plattform zu teilen, ohne Daten zu teilen. Die Verträge Ihrer Kunden sind nur für die Personen sichtbar, die Sie in Ihre Organisation einladen."
        }
      ],
      "faq": [
        {
          "q": "Können Empfänger ohne Konto ihre Rechte ausüben?",
          "a": "Ja. Sie stellen eine Anfrage mit ihrer E-Mail-Adresse und erhalten einen Link per E-Mail. Die Antwort verrät nie, ob die Adresse im System existiert."
        },
        {
          "q": "Werden signierte Dokumente bei der Löschung entfernt?",
          "a": "Nein. Personenbezogene Daten werden anonymisiert, signierte Dokumente bleiben jedoch erhalten, um die Nachweise und die Rechte der anderen Parteien zu wahren."
        },
        {
          "q": "Sind meine Daten verschlüsselt?",
          "a": "Ja. Dokumente werden im Ruhezustand mit AES-256-GCM und einem eigenen Schlüssel pro Organisation verschlüsselt."
        }
      ]
    }
  },
  "groups": {
    "trust": "Vertrauen & Recht",
    "brand": "Ihre Marke",
    "docs": "Arbeiten mit Dokumenten",
    "dev": "Für Entwickler"
  },
  "plans": {
    "starter": [
      "50 Dokumente / Monat",
      "3 Nutzer, 1 Team",
      "Verifizierung per E-Mail-Code",
      "\"Powered by sign.yt\" auf Anmeldeseiten"
    ],
    "professional": [
      "500 Dokumente / Monat",
      "10 Nutzer, 5 Teams",
      "50 SMS-Codes / Monat",
      "Eigene Domain, kein Wasserzeichen"
    ],
    "business": [
      "Unbegrenzt Dokumente, Nutzer und Teams",
      "SSO",
      "Eigener E-Mail-Anbieter",
      "REST API und Webhooks"
    ],
    "enterprise": [
      "Alles aus Business",
      "SAML",
      "SLA und dedizierter Support",
      "On-Premise-Option"
    ]
  },
  "pricingFaq": [
    {
      "q": "Sind die Preise netto oder brutto?",
      "a": "Alle Preise sind monatliche Nettopreise in PLN. Die polnische Mehrwertsteuer (23 %) wird auf der Rechnung hinzugefügt."
    },
    {
      "q": "Was passiert, wenn wir das Dokumentenlimit überschreiten?",
      "a": "Bezahlte Tarife laufen weiter. Dokumente über dem monatlichen Limit werden mit je 2 PLN auf Ihrer nächsten Rechnung berechnet, und Admins erhalten bei 80 % und 100 % des Limits eine E-Mail-Benachrichtigung."
    },
    {
      "q": "Stellen Sie Rechnungen mit Mehrwertsteuer aus?",
      "a": "Ja. Zu jeder Zahlung gibt es eine Rechnung mit ausgewiesener Mehrwertsteuer für Ihr Unternehmen, mit Ihrer Steuernummer und Rechnungsadresse aus den Organisationseinstellungen."
    },
    {
      "q": "Können wir den Tarif später wechseln?",
      "a": "Ja. Sie können den Tarif jederzeit im Abrechnungsportal wechseln, das Sie über Ihre Abrechnungseinstellungen erreichen. Die Limits richten sich nach dem neuen Tarif."
    },
    {
      "q": "Können wir weitere Teams hinzufügen, ohne in einen größeren Tarif zu wechseln?",
      "a": "Zusätzliche Teams lassen sich gegen eine monatliche Gebühr zu einem bezahlten Tarif hinzufügen. Schreiben Sie uns, und wir richten es für Ihre Organisation ein."
    },
    {
      "q": "Wie funktioniert die Preisgestaltung für Enterprise?",
      "a": "Enterprise wird nach Ihrem Volumen sowie Ihren Sicherheits- und Hosting-Anforderungen angeboten, einschließlich SAML, SLA und On-Premise-Option. Kontakt: sales@sign.yt."
    }
  ],
  "pricingRows": [
    [
      "Dokumente pro Monat",
      [
        "50",
        "500",
        "Unbegrenzt",
        "Unbegrenzt"
      ]
    ],
    [
      "Nutzer",
      [
        "3",
        "10",
        "Unbegrenzt",
        "Unbegrenzt"
      ]
    ],
    [
      "Teams",
      [
        "1",
        "5",
        "Unbegrenzt",
        "Unbegrenzt"
      ]
    ],
    [
      "Verifizierung per E-Mail-Code",
      [
        true,
        true,
        true,
        true
      ]
    ],
    [
      "SMS-Codes",
      [
        false,
        "50 / Monat",
        true,
        true
      ]
    ],
    [
      "Eigene Signatur-Domain",
      [
        false,
        true,
        true,
        true
      ]
    ],
    [
      "Ihr Branding, ohne \"Powered by\"",
      [
        false,
        true,
        true,
        true
      ]
    ],
    [
      "SSO (Google, Microsoft, OIDC)",
      [
        false,
        false,
        true,
        true
      ]
    ],
    [
      "Eigener E-Mail-Anbieter",
      [
        false,
        false,
        true,
        true
      ]
    ],
    [
      "REST API und Webhooks",
      [
        false,
        false,
        true,
        true
      ]
    ],
    [
      "SAML",
      [
        false,
        false,
        false,
        true
      ]
    ],
    [
      "SLA und dedizierter Support",
      [
        false,
        false,
        false,
        true
      ]
    ],
    [
      "On-Premise-Option",
      [
        false,
        false,
        false,
        true
      ]
    ]
  ],
  "pages": {
    "home": {
      "title": "sign.yt: E-Signatur auf Ihrer eigenen Domain",
      "desc": "Plattform für elektronische Signaturen für Büros, Coworkings und Kanzleien: eigene Domain und Branding, PAdES-Siegel, SMS- und E-Mail-Verifizierung.",
      "h1": "Verträge, unterschrieben unter Ihrem eigenen Namen.",
      "lead": "sign.yt führt den gesamten Signaturablauf auf Ihrer Domain aus, mit Ihrem Logo und Ihrem E-Mail-Absender. Unterzeichner verifizieren sich per E-Mail- oder SMS-Code, und jedes PDF kommt mit PAdES-Siegel und vollständigem Audit-Trail zurück."
    },
    "hub": {
      "title": "E-Signatur-Funktionen: Domains, PAdES, API",
      "desc": "Alles, was sign.yt kann: eigene Domains, Branding, PAdES, Zeitstempel, Bitcoin-Verankerung, Post-Quanten-Siegel, QR-Prüfung, API und DSGVO-Werkzeuge.",
      "h1": "Alles, was Sie brauchen, um Dokumente online zu unterschreiben",
      "lead": "Jede der folgenden Funktionen gibt es heute im Produkt. Wählen Sie eine aus, um zu sehen, wie sie funktioniert."
    },
    "pricing": {
      "title": "E-Signatur Preise: Tarife in PLN",
      "desc": "Monatliche E-Signatur-Tarife in PLN: {plans}, Enterprise auf Anfrage. Nettopreise zzgl. MwSt., Tarif jederzeit änderbar.",
      "h1": "Tarife, die mit Ihren Büros wachsen",
      "lead": "Monatliche Nettopreise in PLN. Starten Sie klein und wechseln Sie nach oben, wenn Sie eigene Domains, SSO oder die API brauchen."
    }
  },
  "labels": {
    "home": "Startseite",
    "features": "Funktionen",
    "pricing": "Preise",
    "faq": "Häufig gestellte Fragen",
    "month": "Monat",
    "custom": "Individuell",
    "contact": "Vertrieb kontaktieren",
    "verify": "Dokument prüfen",
    "all": "Alle Funktionen",
    "more": "Weitere Funktionen",
    "language": "Sprache",
    "breadcrumb": "Brotkrümelnavigation",
    "not_found_title": "Seite nicht gefunden",
    "not_found_lead": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "back_home": "Zur Startseite"
  },
  "ui": {
    "skip": "Zum Inhalt springen",
    "nav_label": "Hauptnavigation",
    "features": "Funktionen",
    "pricing": "Preise",
    "faq": "FAQ",
    "verify": "Dokument prüfen",
    "developers": "Entwickler & API",
    "language": "Sprache",
    "sign_in": "Anmelden",
    "book_demo": "Demo buchen",
    "dashboard": "Zum Dashboard",
    "menu": "Menü",
    "footer_blurb": "E-Signaturen auf Ihrer eigenen Domain, mit Ihrem Branding und Ihrem E-Mail-Absender. Gemacht für Büros, Coworkings und Kanzleien.",
    "footer_product": "Produkt",
    "footer_company": "Unternehmen",
    "footer_legal": "Rechtliches",
    "all_features": "Alle Funktionen",
    "contact": "Kontakt",
    "status": "Status",
    "privacy": "Datenschutzerklärung",
    "terms": "Nutzungsbedingungen",
    "dpa": "Auftragsverarbeitungsvertrag",
    "subprocessors": "Unterauftragsverarbeiter",
    "rodo": "Meine Daten anfordern (DSGVO)",
    "faq_title": "Häufig gestellte Fragen",
    "cta_title": "Testen Sie es mit Ihren eigenen Dokumenten",
    "cta_lead": "Buchen Sie eine kurze Demo, und wir richten eine Test-Organisation mit Ihrer Domain und Ihrem Branding ein.",
    "not_found_title": "Seite nicht gefunden",
    "not_found_lead": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "back_home": "Zur Startseite",
    "home": "Startseite",
    "breadcrumb": "Brotkrümelnavigation",
    "feature_kicker": "Funktion",
    "more_features": "Weitere Funktionen",
    "see_all": "Alle Funktionen ansehen",
    "see_pricing": "Preise ansehen",
    "read_more": "Mehr erfahren",
    "per_month": "PLN / Monat",
    "net_note": "netto zzgl. MwSt.",
    "custom_price": "Individuell",
    "custom_note": "Preis nach Ihrem Volumen",
    "recommended": "Empfohlen",
    "choose_plan": "Auswählen",
    "contact_sales": "Vertrieb kontaktieren",
    "compare_kicker": "Im direkten Vergleich",
    "compare_title": "Tarife vergleichen",
    "feature_col": "Funktion",
    "included": "Enthalten",
    "not_included": "Nicht enthalten",
    "scroll_hint": "Seitlich wischen, um alle Tarife zu vergleichen",
    "dev_title": "Jetzt integrieren",
    "dev_lead": "Vollständige API-Referenz, ein Schnellstart in fünf Minuten und offizielle SDKs für Python und TypeScript.",
    "dev_reference": "API-Referenz",
    "dev_quickstart": "Schnellstart",
    "dev_sdks": "SDKs",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "pricing_faq_title": "Fragen zur Abrechnung",
    "not_found_try": "Vielleicht suchten Sie",
    "lang_suggest": "Diese Seite gibt es auch auf Deutsch.",
    "lang_switch": "Auf Deutsch lesen",
    "lang_dismiss": "Nein, danke"
  },
  "examples": {
    "api": {
      "log": "Webhook-Zustellungen",
      "target": "crm.example.pl/hooks/sign"
    },
    "audit": {
      "ok": "Kette intakt",
      "rows": [
        [
          "Dokument erstellt",
          "anna@example.pl"
        ],
        [
          "An Unterzeichner gesendet",
          "jan@example.pl"
        ],
        [
          "Geöffnet",
          "83.12.x.x · Firefox"
        ],
        [
          "SMS-Code verifiziert",
          "+48 600 *** 412"
        ],
        [
          "Unterschrieben",
          "83.12.x.x · 09:33:10"
        ]
      ]
    },
    "bitcoin": {
      "file": "signiert.pdf",
      "block": "Block",
      "ok": "Verankert"
    },
    "bulk": {
      "docs": "4 Dokumente",
      "progress": "2 von 4 unterschrieben",
      "st": {
        "signed": "Unterschrieben",
        "viewed": "Angesehen",
        "sent": "Gesendet"
      }
    },
    "domains": {
      "title": "Eigene Domain",
      "type": "Typ",
      "name": "Name",
      "target": "Zeigt auf",
      "status": "Status",
      "verified": "Verifiziert",
      "tls": "TLS-Zertifikat ausgestellt",
      "doc": "Mietvertrag, Büro 2.14",
      "sign": "Unterschreiben",
      "host": "sign.ihrefirma.de"
    },
    "templates": {
      "search": "Vorlagen durchsuchen",
      "fields": "Felder",
      "items": [
        [
          "Büromietvertrag",
          "Miete",
          9
        ],
        [
          "NDA, gegenseitig",
          "Recht",
          4
        ],
        [
          "Nachtrag zum Vertrag",
          "Miete",
          5
        ],
        [
          "Marketing-Einwilligung",
          "DSGVO",
          2
        ]
      ]
    },
    "email": {
      "title": "E-Mail-Anbieter",
      "from": "Absender",
      "test": "Test-E-Mail zugestellt",
      "managed": "Verwaltet"
    },
    "gdpr": {
      "req": "Betroffenenanfrage",
      "exp": "Export",
      "erase": "Löschen",
      "steps": [
        "Identität bestätigt",
        "Daten aus 3 Dokumenten gesammelt",
        "Signierte Verträge bleiben, gesetzliche Aufbewahrung"
      ],
      "zip": "ZIP herunterladen",
      "foot": "Hosting in der EU · AES-256-GCM im Ruhezustand"
    },
    "mobile": {
      "title": "Ihre Unterschrift",
      "sign": "Unterschreiben",
      "left": "Noch 1 von 2 Feldern"
    },
    "pades": {
      "valid": "Signatur gültig",
      "signer": "Unterzeichnet von",
      "format": "Format",
      "time": "Signaturzeitpunkt",
      "intact": "Seit der Unterzeichnung unverändert",
      "file": "vertrag-signiert.pdf"
    },
    "pz": {
      "steps": [
        "Prüfen",
        "Methode",
        "Unterschreiben"
      ],
      "choose": "Wählen Sie, wie Sie unterschreiben",
      "opts": [
        [
          "Profil Zaufany",
          "Kostenlos, über login.gov.pl"
        ],
        [
          "e-dowód",
          "Personalausweis mit NFC"
        ],
        [
          "Qualifizierte E-Signatur",
          "Vertrauensdiensteanbieter"
        ]
      ],
      "btn": "Mit Profil Zaufany unterschreiben",
      "note": "Sie werden zu Węzeł Podpisu weitergeleitet"
    },
    "smart": {
      "nip": "NIP des Mieters",
      "fetched": "In Registern gefunden",
      "name": "Firmenname",
      "addr": "Sitz",
      "vat": "USt-Status",
      "active": "Aktiver USt-Zahler, EU-USt-ID gültig",
      "gen": "Vertrag erzeugen"
    },
    "sms": {
      "title": "Bestätigen Sie, dass Sie es sind",
      "sent": "Wir haben einen 6-stelligen Code gesendet an",
      "email": "E-Mail",
      "resend": "Code erneut senden in 0:42",
      "go": "Weiter zum Dokument"
    },
    "brand": {
      "doc": "Dienstleistungsvertrag",
      "sign": "Unterschreiben",
      "from": "von"
    }
  },
  "home": {
    "get_started": "Jetzt starten",
    "hero_line1": "Verträge, unterschrieben",
    "hero_line2": "unter Ihrem eigenen Namen.",
    "hero_sub": "sign.yt führt den gesamten Signaturablauf auf Ihrer Domain aus, mit Ihrem Logo und Ihrem E-Mail-Absender. Unterzeichner verifizieren sich per E-Mail- oder SMS-Code, und jedes PDF kommt mit PAdES-Siegel und vollständigem Audit-Trail zurück.",
    "cta_demo_sign_in": "Anmelden",
    "cta_view_signing": "Signaturseite ansehen",
    "cta_see_pricing": "Preise ansehen",
    "cta_start_free": "Kostenlos testen",
    "nav_features": "Funktionen",
    "nav_pricing": "Preise",
    "nav_plans": "Tarife",
    "nav_contact": "Kontakt",
    "cta_book_demo": "Demo buchen",
    "plans_title": "Sie zahlen für Dokumente, nicht für Unterzeichner.",
    "plans_sub": "Preise in PLN netto zzgl. MwSt., monatliche Abrechnung. Unterzeichner zahlen nie und brauchen kein Konto.",
    "plans_note": "Jeder Tarif enthält PDFs mit PAdES-Siegel, Hosting in der EU und einen vollständigen Audit-Trail.",
    "tier_contact_cta": "Kontakt aufnehmen",
    "contact_title": "Sprechen wir über Ihre Dokumente",
    "contact_sub": "Erzählen Sie uns, was Sie unterschreiben lassen, wie viele Dokumente ungefähr pro Monat anfallen und welche Domain Sie nutzen möchten. Wir antworten mit einem Demo-Termin und einer Test-Organisation.",
    "contact_email_cta": "E-Mail schreiben",
    "contact_response_time": "Wir antworten in der Regel innerhalb eines Werktags.",
    "footer_company": "Unternehmen",
    "features_title": "Alles, was ein Signatur-Büro braucht, und nichts darüber hinaus",
    "features_sub": "Gemacht für Teams, die täglich Verträge versenden und möchten, dass diese nach ihnen selbst aussehen.",
    "feature_custom_domains_title": "Eigene Domains",
    "feature_custom_domains_body": "Jeder Kunde auf seiner eigenen Subdomain mit eigenem Branding. Eine Funktion, die kein großer Anbieter bietet.",
    "feature_pades_title": "PAdES-Signaturen",
    "feature_pades_body": "PDFs, signiert im PAdES-Format (ETSI EN 319 142).",
    "feature_dev_first_title": "Für Entwickler gemacht",
    "feature_dev_first_body": "Vollständige REST API, Webhooks, SDKs, MCP-Server für KI-Agenten.",
    "feature_wezel_title": "Bereit für Węzeł Podpisu",
    "feature_wezel_body": "Native Integration mit Węzeł Podpisu (staatlicher polnischer Signaturdienst): Profil Zaufany, e-dowód, qualifizierte Signatur, mObywatel.",
    "feature_rodo_title": "DSGVO / RODO von Anfang an",
    "feature_rodo_body": "Datenexport nach Artikel 20, Anonymisierung nach Artikel 17, Hash-Kette im Audit-Trail, Hosting in Polen.",
    "feature_i18n_title": "5 Sprachen ab Werk",
    "feature_i18n_body": "Englisch, Polnisch, Ukrainisch, Deutsch, Spanisch. Weitere lassen sich im laufenden Betrieb ohne neues Release hinzufügen.",
    "feature_api_title": "API-first",
    "feature_api_body": "Alles aus der Oberfläche gibt es auch in der REST API. Die OpenAPI-Spezifikation wird automatisch unter api.sign.yt veröffentlicht.",
    "pricing_title": "Faire Preise, transparente Limits",
    "pricing_sub": "Monatliche Zahlung. Kein Aufpreis pro Signatur für die ersten 500 Dokumente. Jederzeit kündbar.",
    "tier_starter": "Starter",
    "tier_starter_blurb": "Für ein einzelnes Büro, das gerade startet.",
    "tier_starter_b1": "50 Dokumente / Monat",
    "tier_starter_b2": "3 Nutzer, 1 Team",
    "tier_starter_b3": "Verwalteter E-Mail-Versand, E-Mail-OTP",
    "tier_starter_cta": "Starter testen",
    "tier_pro": "Professional",
    "tier_pro_blurb": "Für Teams, die eine eigene Domain möchten.",
    "tier_pro_b1": "500 Dokumente / Monat",
    "tier_pro_b2": "10 Nutzer, 5 Teams",
    "tier_pro_b3": "Eigene Domain, kein Wasserzeichen",
    "tier_pro_b4": "SMS-OTP (50 / Monat)",
    "tier_pro_cta": "Mit Pro starten",
    "tier_business": "Business",
    "tier_business_blurb": "Für Betreiber mit mehreren Marken.",
    "tier_business_b1": "Unbegrenzt Dokumente",
    "tier_business_b2": "Unbegrenzt Nutzer und Teams",
    "tier_business_b3": "SSO, Webhooks, API-Schlüssel, eigener E-Mail-Anbieter",
    "tier_business_b4": "Bevorzugter Support",
    "tier_business_cta": "Mit dem Vertrieb sprechen",
    "tier_enterprise": "Enterprise",
    "tier_enterprise_blurb": "Für individuelle Verträge und On-Premise.",
    "tier_enterprise_b1": "Alles aus Business",
    "tier_enterprise_b2": "SAML SSO, SLA, AVV",
    "tier_enterprise_b3": "Dedizierter Success Engineer",
    "tier_enterprise_cta": "Kontakt aufnehmen",
    "most_popular": "Empfohlen",
    "pln_per_month": "PLN / Monat",
    "custom": "Individuell",
    "trust_eu_hosted": "Hosting in der EU",
    "trust_pades": "PAdES-Siegel",
    "trust_rodo": "DSGVO / RODO",
    "trust_audit": "Audit-Hash-Kette",
    "who_title": "Gemacht für alle, die am meisten unterschreiben lassen",
    "who_sub": "Drei Arten von Teams, für die wir sign.yt gebaut haben.",
    "segment_biura_title": "Virtuelle Büros und Coworking",
    "segment_biura_body": "Miet- und Dienstleistungsverträge, unterschrieben auf Ihrer Domain und unter Ihrer Marke. Jede Marke läuft als eigene Organisation mit eigener Domain, und ein Login wechselt zwischen ihnen.",
    "segment_kancelarie_title": "Anwalts- und Steuerkanzleien",
    "segment_kancelarie_body": "Mandatsvereinbarungen und Einwilligungen mit versiegeltem PDF und einem Audit-Trail für die Mandantenakte.",
    "segment_hr_title": "Personalabteilungen",
    "segment_hr_body": "Angebote, NDAs und Nachträge im Massenversand aus Vorlagen, mit separater Nachverfolgung jedes Unterzeichners.",
    "faq_title": "Häufig gestellte Fragen",
    "faq_q1": "Sind diese Signaturen rechtsverbindlich?",
    "faq_a1": "Ja. Nach eIDAS darf eine elektronische Signatur nicht allein deshalb als Beweismittel abgelehnt werden, weil sie elektronisch ist. sign.yt versiegelt jedes signierte PDF (PAdES) und führt einen Audit-Trail darüber, wer wann unterschrieben hat und wie die Person verifiziert wurde. Für Dokumente, die eine strengere Form brauchen, können Unterzeichner Profil Zaufany (staatliches polnisches eID-Profil) nutzen, sofern aktiviert.",
    "faq_q2": "Kann ich meine eigene Domain und meinen eigenen E-Mail-Absender nutzen?",
    "faq_a2": "Ja. Ab dem Tarif Professional können Sie eine Signatur-Domain wie sign.ihrefirma.de mit automatischem TLS-Zertifikat hinzufügen. Ab dem Tarif Business können E-Mails auch über Ihr eigenes SMTP, Microsoft 365, Resend, Amazon SES oder Mailgun versendet werden, sodass Einladungen von Ihrer eigenen Adresse kommen.",
    "faq_q3": "Wie bestätigen Unterzeichner ihre Identität?",
    "faq_a3": "Sie wählen pro Dokument: kein zusätzlicher Schritt, ein Einmalcode per E-Mail oder ein Einmalcode per SMS. Die verwendete Methode wird im Audit-Trail festgehalten.",
    "faq_q4": "Gibt es eine API?",
    "faq_a4": "Ja. Mit einer REST API und API-Schlüsseln mit Scopes erstellen und versenden Sie Dokumente aus Ihrem eigenen System, und Webhooks benachrichtigen Sie, wenn ein Dokument angesehen, unterschrieben oder abgeschlossen wurde.",
    "final_cta_title": "Ihre Kunden unterschreiben. Die Anerkennung bekommen Sie.",
    "final_cta_sub": "Buchen Sie eine kurze Demo, und wir richten eine Test-Organisation mit Ihrem Branding ein.",
    "footer_tag": "E-Signaturen auf Ihrer eigenen Domain.",
    "footer_product": "Produkt",
    "footer_developers": "Entwickler",
    "footer_legal": "Rechtliches",
    "footer_privacy": "Datenschutz",
    "footer_terms": "Bedingungen",
    "footer_made_in_pl": "Made in Poland",
    "footer_made_with": "Gemacht mit",
    "footer_in_poland_by": "in Polen von",
    "hero_kicker": "E-Signatur für Büros, Kanzleien und Personalabteilungen",
    "hero_note": "Preise ab 49 PLN / Monat netto zzgl. MwSt. Hosting in der EU.",
    "cta_dashboard": "Zum Dashboard",
    "how_kicker": "So funktioniert es",
    "how_title": "Vom PDF zum versiegelten Vertrag in fünf Schritten",
    "step1_title": "PDF hochladen",
    "step1_body": "Laden Sie einen Vertrag hoch oder starten Sie mit einer gespeicherten Vorlage. Smarte Dokumente füllen Firmendaten anhand der Steuernummer aus GUS, VIES und der VAT-Whitelist aus.",
    "step2_title": "Felder platzieren",
    "step2_body": "Ziehen Sie Signatur-, Datums-, Text- und Kontrollkästchenfelder auf die Seite und weisen Sie sie den Empfängern zu. Wählen Sie parallele oder sequenzielle Unterzeichnung.",
    "step3_title": "Unter Ihrer Domain senden",
    "step3_body": "Einladungen gehen von Ihrem eigenen E-Mail-Absender aus, und der Signaturlink öffnet sich auf sign.ihrefirma.de mit Ihrem Branding.",
    "step4_title": "Der Unterzeichner verifiziert sich",
    "step4_body": "Vor der Unterzeichnung bestätigen Empfänger ihre Identität mit einem Einmalcode per E-Mail oder SMS. Sofern aktiviert, können sie auch mit Profil Zaufany unterschreiben.",
    "step5_title": "Versiegeltes PDF und Audit-Trail",
    "step5_body": "Das finale PDF trägt ein PAdES-Siegel, das jeder prüfen kann, sowie einen Audit-Trail, in dem jedes Ereignis per Hash mit dem vorherigen verkettet ist.",
    "features_kicker": "Funktionen",
    "features_all": "Alle {n} Funktionen",
    "bento_domains_title": "Eigene Domains",
    "bento_domains_body": "Signaturlinks öffnen sich auf sign.ihrefirma.de. Ein CNAME-Eintrag, TLS automatisch ausgestellt.",
    "bento_pades_title": "PAdES-Siegel",
    "bento_pades_body": "Ein kryptografisches Siegel auf jedem PDF, dazu ein per Hash verketteter Audit-Trail.",
    "bento_verify_title": "Wissen, wer unterschrieben hat",
    "bento_verify_body": "E-Mail- oder SMS-Codes, dazu Profil Zaufany (staatliches polnisches eID-Profil), e-dowód (polnischer elektronischer Personalausweis) oder mObywatel (staatliche polnische ID-App) über Węzeł Podpisu (staatlicher polnischer Signaturdienst), sofern aktiviert.",
    "bento_smart_title": "Smarte Dokumente",
    "bento_smart_body": "Steuernummer eingeben, und die Firmendaten kommen aus GUS, VIES und der VAT-Whitelist.",
    "bento_api_title": "REST API und Webhooks",
    "bento_api_body": "Erstellen und versenden Sie Dokumente aus Ihrem eigenen System und werden Sie benachrichtigt, sobald sie unterschrieben sind.",
    "who_kicker": "Für wen",
    "plans_kicker": "Preise",
    "plans_compare": "Tarife vergleichen",
    "plans_per_month": "PLN / Monat netto zzgl. MwSt.",
    "security_kicker": "Sicherheit und Compliance",
    "security_title": "Gebaut, um jedem Audit standzuhalten",
    "trust_eu_hosted_body": "Daten und Dokumente bleiben auf Servern in der Europäischen Union.",
    "trust_pades_body": "Signierte PDFs lassen sich in jedem Standard-Reader prüfen, oder über den QR-Code und Kurzlink auf jedem Dokument.",
    "trust_rodo_body": "Datenexport und Löschanfragen sind integriert, nicht per E-Mail abgewickelt.",
    "trust_audit_body": "Ein manipulationssicheres Log jeder Ansicht, Verifizierung und Signatur.",
    "faq_kicker": "FAQ",
    "faq_q5": "Welche Sprachen werden unterstützt?",
    "faq_a5": "Die App und die Signaturseiten sind auf Englisch, Polnisch, Ukrainisch, Deutsch und Spanisch verfügbar.",
    "faq_q6": "Wo werden meine Daten gespeichert?",
    "faq_a6": "Auf Servern in der Europäischen Union. Personenbezogene Daten können Sie auf Anfrage exportieren oder löschen, wie es die DSGVO verlangt.",
    "contact_kicker": "Kontakt",
    "bento_brand_title": "Ihre Marke, nicht unsere",
    "bento_brand_body": "Logo, Farben, vier Seitenthemen und E-Mail-Vorlagen. Teams können auf Signaturseiten, Prüfseiten und in E-Mails ihr eigenes Erscheinungsbild nutzen.",
    "cta_show_demo": "Demo ansehen",
    "demo_note": "Ohne Registrierung. Eine private Sandbox mit Beispielverträgen, die automatisch gelöscht wird."
  }
}

export default pack
